import React from "react";
import Breadcrumb from "../components/Breadcrumb";
import AddAssignCourse from "../components/AddAssignCourse";


const AddAssignCoursePage = () => {
  return (
    <>
   
        {/* Breadcrumb */}
        <div className="d-flex justify-content-between"><h5>Assign Course  </h5><Breadcrumb title="Assign Course" /></div>


        {/* AddUserLayer */}
        <AddAssignCourse />

    </>
  );
};

export default AddAssignCoursePage;
